// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__38eFR","popper":"styles_popper__2gYI1","content":"styles_content__Kkeyt","tab":"styles_tab__4JZQz","disabled":"styles_disabled__3Z6aV"};